import styled from "styled-components";

const Wrapper = styled.section`
  text-align: left;
  background-color: none;
  .lets-talk {
    color: var(--white);
    text-align: left;
  }
  .icon {
    color: var(--white);
    width: 20px;
    height: 20px;
  }
  dl {
    display: flex;
    flex-direction: column;
    row-gap: 1rem;

    div {
      display: grid;
      grid-template-columns: 30px auto;
      justify-content: start;
      align-items: start;
      h5 {
        color: var(--white);
        text-transform: none;
      }
    }
  }

  @media screen and (max-width: 900px) {
    background-color: var(--background-color);
    .lets-talk {
      color: var(--text-color);
    }
    .icon {
      color: var(--text-color);
    }
    dl div h5 {
      color: var(--text-color);
    }
  }
`;

export default Wrapper;
